import { useNavigate } from 'react-router-dom';

import { Icon as Iconify } from '@iconify/react';
import { IconButton } from '@mui/material';
import { useEffect, useState } from 'react';
import {SnippetCodeViewer} from '../commonComponents/snippetGeneric'


import { useParams } from "react-router-dom";
import axios from 'axios';

import BarcodeWorkflow from '../workflows/barcodesWorkflow';


// ----------------------------------------------------------------------


export default function BarcodesWizard(props) {
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [snippetData, setSnippetData] = useState(undefined)



  let params = useParams();
  const navigate = useNavigate();

  const [activeErrorList, setActiveErrorList] = useState([]);


  useEffect(() => {
      //console.log(params)
    if (params.snippetId !== undefined) {
      getSnippetInfo(params.snippetId)
    }
  }, [params])

  const getSnippetInfo = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

        const dataObj = {...data, snippetSettings: JSON.parse(data.snippetSettings)}
      setSnippetData(dataObj);

    } catch (error) {
      console.log(error);
    }
  }



 return (
  <>
        <BarcodeWorkflow />

  </>
);
}
